// Story 11.1 — Hooks para `GET /bots/:id/files` y file content.

import { useQuery } from '@tanstack/react-query';
import { filesApi } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

export function useFiles(botId: number) {
  return useQuery({
    queryKey: queryKeys.files(botId),
    queryFn: () => filesApi.tree(botId),
    enabled: Number.isFinite(botId),
    staleTime: 60_000,
  });
}

export function useFileContent(botId: number, path: string | null) {
  return useQuery({
    queryKey: queryKeys.fileContent(botId, path ?? ''),
    queryFn: () => filesApi.content(botId, path as string),
    enabled: Number.isFinite(botId) && !!path,
    staleTime: 60_000,
  });
}
